package com.milta.feature.team.data.remote.dto

import com.milta.feature.team.domain.entity.Driver
import kotlinx.serialization.Serializable

/** Mirrors the backend DriverDto (GET /enterprises/{id}/drivers). */
@Serializable
data class DriverDto(
    val id: String,
    val firstName: String,
    val lastName: String,
    val phoneNumber: String,
)

fun DriverDto.toDomain() = Driver(
    id = id,
    firstName = firstName,
    lastName = lastName,
    phoneNumber = phoneNumber,
)
